function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlignleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.75v16.5a.75.75 0 11-1.5 0V3.75a.75.75 0 011.5 0zm3 7.5h9a1.502 1.502 0 001.5-1.5V6a1.502 1.502 0 00-1.5-1.5h-9A1.502 1.502 0 006 6v3.75a1.502 1.502 0 001.5 1.5zm12.75 1.5H7.5a1.502 1.502 0 00-1.5 1.5V18a1.502 1.502 0 001.5 1.5h12.75a1.502 1.502 0 001.5-1.5v-3.75a1.502 1.502 0 00-1.5-1.5z",
    fill: props.fill
  }));
}

export default SvgAlignleft;